import { render, staticRenderFns } from "./SelectInstituicaoFinanceira.vue?vue&type=template&id=19fffe4c&scoped=true"
import script from "./SelectInstituicaoFinanceira.vue?vue&type=script&lang=js"
export * from "./SelectInstituicaoFinanceira.vue?vue&type=script&lang=js"
import style0 from "./SelectInstituicaoFinanceira.vue?vue&type=style&index=0&id=19fffe4c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fffe4c",
  null
  
)

export default component.exports